import React from 'react';
import {DialogTitle, DialogTitleProps, IconButton, Stack, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export interface BaseDialogTitleProps extends DialogTitleProps {
    onClose: () => void,
    title?: string,
}

function BaseDialogTitle({onClose, title, ...rest}: BaseDialogTitleProps) {
    return (
        <DialogTitle {...rest}>
            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                <Typography variant={'h5'} fontWeight={600} lineHeight={'1.2'} fontSize={'1.5rem'}>
                    {title}
                </Typography>

                <IconButton color="secondary"
                            onClick={onClose} >
                    <CloseIcon/>
                </IconButton>

            </Stack>
        </DialogTitle>
    );
}

export default BaseDialogTitle;